<template>
  <v-row class="px-0 mt-10">
    <v-col cols="auto" class="my-3 px-1 py-0 blogs-header card-border-radius">
      <h2 data-testid="bookmarked-blogs-heading" class="font-weight-bold text-center">
        Bookmarks
      </h2>
    </v-col>
    <v-col
        cols="12"
        v-if="!loading && hasData"
        data-testid="blogs-list"
        class="card-border-radius d-flex flex-column pa-10"
        style="background-color: #FFFFFF;"
    >
      <div class="d-flex flex-row flex-wrap justify-space-between" >
        <BlogCard
            v-for="(blog) in blogs"
            :key="blog.slug"
            :blog="blog"
            is-bookmark
            show-border
            @onDeleteBookmark="handleDeleteBookmark($event)"
        />
      </div>
    </v-col>
    <v-col cols="12" v-if="!loading">
      <infinite-loading spinner="waveDots" @infinite="fetchMoreBlogs">
        <div slot="no-results">
          <v-chip small text-color="primary">You have caught up</v-chip>
        </div>
        <div slot="no-more">
          <v-chip small text-color="primary">You have caught up</v-chip>
        </div>
      </infinite-loading>
    </v-col>
    <v-col cols="12" v-if="(!loading && !hasData)" class="bottom-wrapper">
      <NoData
          data-testid="empty-blogs-list"
          :image="emptyPage"
          :title="`No bookmarked blogs yet`"
      />
    </v-col>
    <v-col cols="12" v-if="loading" class="d-flex flex-row flex-wrap justify-space-around">
      <v-skeleton-loader
          data-testid="v-skeleton-loader"
          v-for="x in 9"
          :key="x"
          class="my-3"
          type="card,article,list-item-avatar-three-line"
          :width="$vuetify.breakpoint.xs ? '99%' : '30%'"
      />
    </v-col>
  </v-row>
</template>
<script>

import {mapGetters, mapMutations} from "vuex";
import Logo from "@/assets/guiomentorLogo.png";
import BlogCard from "@/components/BlogCard";
import emptyPage from "@/assets/no_data.svg";
import NoData from "@/components/NoData";
import IsAuthenticatedMixin from "@/mixins/IsAuthenticatedMixin";
import InfiniteScroll from "@/mixins/InfiniteScroll";

export default {
  metaInfo() {
    return {
      title: 'Guiomentor - Bookmarked Blogs',
      url: window.location.href,
    }
  },
  components: {BlogCard, NoData},
  mixins: [IsAuthenticatedMixin, InfiniteScroll],
  data: () => ({
    emptyPage,
    showLogOutDialog: false,
    drawerOpen: true,
    limit: 5,
    offset: 5,
    loading: false,
    fetchUrl: "",
    logo: Logo,

  }),
  beforeMount() {
    this.fetchUrl = `blogs/bookmarks/?limit=${this.limit}&order_by=blog_views`
    this.SET_BOOKMARKED_BLOGS([])
    this.loadBlogs()
  },
  computed: {
    ...mapGetters({
      user: "auth/GET_USER",
      blogs: "blogs/GET_BOOKMARKED_BLOGS"
    }),
    hasData() {
      return Boolean(this.blogs.length)
    },
  },
  methods: {
    ...mapMutations({
      SET_BOOKMARKED_BLOGS: "blogs/SET_BOOKMARKED_BLOGS"
    }),
    async handleDeleteBookmark(blog) {
      try {
        await this.axios.post(`blogs/bookmarks/${blog.slug}/`);
        this.SET_BOOKMARKED_BLOGS(...[this.blogs.filter((post) => post.uuid !== blog.uuid)])
        this.$snackbar.showMessage({
          content: "Bookmark was deleted successfully.",
          color: "success",
        });
        this.$analytics.logEvent("bookmark_blog", {
          blog: blog.slug,
          time: new Date(),
          url: window.location.href,
          version: process.env.VUE_APP_VERSION,
          environment: process.env.VUE_APP_ENVIRONMENT,
        });
      } catch (error) {
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      }
    },
    async loadBlogs() {
      try {
        this.loading = true
        const {data} = await this.axios.get(this.fetchUrl)
        this.SET_BOOKMARKED_BLOGS(data.results)
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$snackbar.showMessage({
          content: this.$t('errors.somethingWentWrongError'),
          color: "error",
        });
      }
    },
    fetchMoreBlogs($state) {
      this.infiniteHandler($state, "SET_BOOKMARKED_BLOGS")
    }
  }
}
</script>
<style lang="scss" scoped>
.blogs-header {
  background-color: #FFFFFF;
  color: #0035B0;
}
.card-border-radius {
  border-radius: .5em;
}
</style>
